import React, { useState } from "react";
import { screenResolution } from "../../../../utils/screenResolution";
import UploadPhotosOfCar from "./uploadPhotosOfCar";
import MobileUploadCarPhotoStepperLayout from "./MobileUploadCarPhotoStepperLayout";

const UploadsMainPage = (passedFrom) => {

    return (
        <>
            {
                screenResolution.mobile ? <MobileUploadCarPhotoStepperLayout passedFrom={passedFrom} /> : <UploadPhotosOfCar passedFrom={passedFrom} />
            }
        </>
    )
};

export default UploadsMainPage;
